import React, { Component } from "react";
import { clientModalRequest } from "../../../../services/complianceAPIServices";
import Modal from "../../../common/Modal";

export default class ClientRequestModal extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      notesDate: new Date().getFullYear(),
      message: "",
    };
  }

  render() {
    const { data, onClose, show } = this.props;

    return (
      <Modal show={show} onClose={onClose} size="lg">
        <div className="modal-header">
          <h4 className="modal-title" id="staticBackdropLabel">
            Message:
          </h4>
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <div className="input-group">
            <textarea
              className="form-control"
              aria-label="With textarea"
              onChange={(e) => {
                this.setState({ message: e.target.value });
              }}
            ></textarea>
          </div>
        </div>
        <div>
          <div className="modal-footer d-flex justify-content-end bd-highlight">
            <div className="bd-highlight">
              <button
                type="button"
                className="btn btn-primary mx-auto"
                onClick={(e) => {
                  clientModalRequest(data, this.state.message);
                  alert("Change Request Sent!");
                  onClose(e);
                }}
              >
                Submit
              </button>
            </div>
            <div className="bd-highlight">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
